import OfferLabelInterface from 'interfaces/offer-label.interface';
import { isMonoOffer } from 'helpers/offers-prepare';

interface OfferWithLabels {
    labels?: (OfferLabelInterface | null)[] | null;
}

export function getOfferLabel(offer?: OfferWithLabels): OfferLabelInterface | null {
    return offer?.labels?.find((label): label is OfferLabelInterface => label !== null) || null;
}

export function getMonoOfferLabel(product: { offers: { count: number; items: OfferWithLabels[]; }; }): OfferLabelInterface | null {
    return isMonoOffer(product) ? getOfferLabel(product.offers.items[0]) : null;
}
